import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { createGlobalStyle } from 'styled-components'

import App from './App';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: "Montserrat";
    src: url("/Montserrat-Light.ttf");
    url("/Montserrat-Light.ttf") format("ttf");
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: "Montserrat";
    src: url("/Montserrat-Bold.ttf");
    url("/Montserrat-Bold.ttf") format("ttf");
    font-weight: 700;
    font-style: normal;
  }

  html {
    height: 100%;
    padding: 0;
    margin: 0;
  }

  body {
    background: rgb(28,60,92);
    background: linear-gradient(180deg, rgba(28,60,92,1) 0%, rgba(22,26,37,1) 100%);
    background-repeat: no-repeat;
    background-attachment: fixed;
    min-height: calc(100% - 40px);
    padding: 20px;
    margin: 0;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    color: #FFFFFF;
  }

  #root {
    height: 100%;
  }
`;

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.unregister();
//serviceWorkerRegistration.register();
process.env.NODE_ENV === 'production' ? serviceWorkerRegistration.register() : serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();